import React from 'react';
import classname from '@search/classname/src';
import './styles.css';

const cn = classname.bind(null, 'MockSnippet');

const MockSnippet: React.FC<{}> = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mixin = (selector: string, ...rest: any) => [ cn('mock'), cn(selector, ...rest) ].join(' ');

    return (
        <div className={cn()} data-test='offer-mock'>
            <div className={cn('wrap')}>
                <div className={mixin('gallary')} />

                <div className={cn('body')}>
                    <div className={cn('generalInfo')}>
                        <div>
                            <div className={mixin('title')} />
                            <div className={mixin('description', { full: true })} />
                            <div className={mixin('description', { full: true })} />
                            <div className={mixin('description', { full: false })} />
                        </div>
                        <div>
                            <div className={mixin('price')} />
                            <div className={mixin('priceDetail')} />
                        </div>
                    </div>

                    <div className={cn('footer')}>
                        <div className={mixin('phone')} />
                        <div className={mixin('avatar')} />
                        <div className={mixin('name')} />
                        <div className={mixin('map')} />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default MockSnippet;
